module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/icon-price-6cd59848d2d4b25eff4a1e929641a9ce.webp";